import type { Locale, Localized } from "./types"

export const ui = {
  nav: {
    home: { nl: "Home", en: "Home" },
    services: { nl: "Diensten", en: "Services" },
    cases: { nl: "Cases", en: "Case Studies" },
    about: { nl: "Over Ons", en: "About" },
    insights: { nl: "Kennis", en: "Insights" },
    contact: { nl: "Contact", en: "Contact" },
  } satisfies Record<string, Localized<string>>,

  cta: {
    getStarted: { nl: "Aan de slag", en: "Get started" },
    contact: { nl: "Neem contact op", en: "Get in touch" },
    readMore: {
      nl: "Lees meer",
      en: "Read more",
    },
    readArticle: { nl: "Lees artikel", en: "Read article" },
    viewCase: { nl: "Bekijk case", en: "View case study" },
    allServices: { nl: "Bekijk alle diensten", en: "View all services" },
    allCases: { nl: "Bekijk alle cases", en: "View all case studies" },
    allInsights: { nl: "Bekijk alle artikelen", en: "View all articles" },
  } satisfies Record<string, Localized<string>>,

  breadcrumbs: {
    home: { nl: "Home", en: "Home" },
    ariaLabel: { nl: "Kruimelpad", en: "Breadcrumb" },
  } satisfies Record<string, Localized<string>>,

  related: {
    services: { nl: "Relevante diensten", en: "Related services" },
    cases: { nl: "Relevante cases", en: "Related case studies" },
    insights: { nl: "Relevante artikelen", en: "Related articles" },
    locations: { nl: "Waar we werken", en: "Where we work" },
  } satisfies Record<string, Localized<string>>,

  footer: {
    tagline: {
      nl: "AI-oplossingen op maat, gebouwd voor jouw bedrijf.",
      en: "Tailored AI solutions, built for your business.",
    },
    navigationTitle: { nl: "Navigatie", en: "Navigation" },
    servicesTitle: { nl: "Diensten", en: "Services" },
    locationsTitle: { nl: "Regio", en: "Region" },
    contactTitle: { nl: "Contact", en: "Contact" },
    followTitle: { nl: "Volg ons", en: "Follow us" },
    allRightsReserved: {
      nl: "Alle rechten voorbehouden.",
      en: "All rights reserved.",
    },
    kvk: { nl: "KvK", en: "CoC" },
  } satisfies Record<string, Localized<string>>,

  privacyLink: { nl: "Privacyverklaring", en: "Privacy Statement" } satisfies Localized<string>,

  notFound: {
    title: { nl: "Pagina niet gevonden", en: "Page not found" },
    body: {
      nl: "De pagina die je zoekt bestaat niet of is verplaatst. Ga terug naar de homepage of bekijk onze diensten.",
      en: "The page you are looking for does not exist or has moved. Head back to the homepage or explore our services.",
    },
    goHome: { nl: "Naar de homepage", en: "Go to the homepage" },
  } satisfies Record<string, Localized<string>>,

  languageNames: {
    nl: "Nederlands",
    en: "English",
  } as Record<Locale, string>,
}

export function t<T>(value: Localized<T>, locale: Locale): T {
  return value[locale]
}
